module.exports = __webpack_public_path__ + "static/media/starry-night.94fab888.png";